<template>
  <Wrapper page-name="图片配置">
    <div class="img-manage">
      <div v-for="(item,idx) in list" :key="item.baseName" class="img-item">
        <span class="label">{{ item.label }}</span>
        <el-upload
          class="avatar-uploader"
          :action="action"
          :headers="headers"
          :data="{fileType: 'image', baseName: item.baseName}"
          :on-success="(res,file)=>{handleImgSuccess(idx,res,file)}"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false">
          <img v-if="item.imgUrl" :src="item.imgUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="recycle">
        <span class="label">爱心回收去向</span>
        <div v-for="(item,idx) in recycleList" :key="item.baseName" class="recycle-item">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :headers="headers"
            :data="{fileType: 'image', baseName: item.baseName}"
            :on-success="(res,file)=>{handleRecycleSuccess(idx,res,file)}"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="item.imgUrl" :src="item.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
    </div>
  </Wrapper>
</template>
<script>
import Wrapper from '@/components/page/Wrapper.vue'
import { getBaseImage } from '@/api/basicConfig'
export default {
  components: {
    Wrapper
  },
  data () {
    const Authorization = this.$cookie.get('Authorization')
    return {
      action: process.env.VUE_APP_UPLOAD_API + '/uploadBaseImage',
      headers: { Authorization },
      list: [{
        label: '我的页面广告图',
        baseName: 'my',
        imgUrl: ''
      }, {
        label: '加入青藤banner图',
        baseName: 'addQingteng',
        imgUrl: ''
      }, {
        label: '商务合作banner图',
        baseName: 'business',
        imgUrl: ''
      }, {
        label: '积分banner图',
        baseName: 'point',
        imgUrl: ''
      }, {
        label: '诉求征集banner图',
        baseName: 'appeal',
        imgUrl: ''
      }, {
        label: '爱心回收banner图',
        baseName: 'recycleBanner',
        imgUrl: ''
      }],
      recycleList: [{
        baseName: 'appeal1',
        imgUrl: ''
      },
      {
        baseName: 'appeal2',
        imgUrl: ''
      }, {
        baseName: 'appeal3',
        imgUrl: ''
      }, {
        baseName: 'appeal4',
        imgUrl: ''
      }]
    }
  },
  mounted () {
    this.getBaseImage()
  },
  methods: {
    getBaseImage () {
      getBaseImage().then(res => {
        const { data } = res
        if (!data.length) return
        data.forEach(item1 => {
          this.list.forEach(item2 => {
            if (item1.baseName === item2.baseName) {
              item2.imgUrl = item1.imgUrl
            }
          })
          this.recycleList.forEach(item3 => {
            if (item1.baseName === item3.baseName) {
              item3.imgUrl = item1.imgUrl
            }
          })
        })
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
      }
      return isJPG && isLt2M
    },
    handleImgSuccess (idx, res, file) {
      this.$set(this.list[idx], 'imgUrl', file.response.data)
    },
    handleRecycleSuccess (idx, res, file) {
      this.$set(this.recycleList[idx], 'imgUrl', file.response.data)
    }
  }
}
</script>
<style lang="scss" scoped>
.img-manage {
  height: calc(100% - 80px);
  margin: 20px;
  padding: 20px;
  position: relative;
  background: #fff;
  font-size: 16px;
  color: #49515C;
  overflow-y: auto;
  .img-item {
    margin-bottom: 30px;
    display: flex;
  }
  .label {
    width: 150px;
    margin-right: 20px;
    text-align: right;
  }
  .recycle {
    display: flex;
    .recycle-item {
      margin-right: 20px;
    }
  }
}
</style>